import { createApiError, normalizeToApiError } from "./error.service";
import { interceptorFetch } from "./interceptor.service";

export async function getBankAccounts(employeeId: number, token: string, updateToken: (newToken: string) => void) {
    try {
        const response = await interceptorFetch(`bank-account/${employeeId}`, token, updateToken, { method: "GET" });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Invalid error response' }));
            throw createApiError(errorData, response.status);
        }

        return await response.json();
    } catch (error) {
        throw normalizeToApiError(error);
    }
}

export async function deleteAccount(id: number, token: string, updateToken: (newToken: string) => void): Promise<{ ok: boolean; message: string }> {
    try {
        const response = await interceptorFetch(`bank-account/${id}`, token, updateToken, {
            method: "DELETE"
        });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Invalid error response' }));
            throw createApiError(errorData, response.status);
        }

        const data = await response.json();
        return { ok: true, message: data.message || 'Bank account deleted successfully.' };
    } catch (error) {
        console.error('Error deleting account:', error);
        return { ok: false, message: `Failed to delete account. ${error}` };
    }
}

export async function buildEarlyRequestTransaction(amountToDeposit: number, accountId: number, bankName: string, accountNumber: string, accountRoutingNumber: string) {
    try {
        const data = {
            "requestedAmount": amountToDeposit,
            "date": new Date(Date.now()).toLocaleString(),
            "bankName": bankName,
            "accountId": accountId,
            "accountNumber": accountNumber,
            "accountRoutingNumber": accountRoutingNumber
        }
        return data;
    } catch (error) {
        return null;
    }
}

export async function requestEarlyWage(requestedAmount: number, bankAccountId: number, employeeId: number, token: string, updateToken: (newToken: string) => void) {
    try {
        const response = await interceptorFetch(`early-wage-request`, token, updateToken, {
            method: "POST",
            body: JSON.stringify({
                amount: requestedAmount,
                bankAccountId,
                employeeId,
            }),
        });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Invalid error response' }));
            throw createApiError(errorData, response.status);
        }

        return await response.json();
    } catch (error) {
        return { ok: false, status: "Failed", message: error instanceof Error ? error.message : "Unexpected error." };
    }
}
